<app-base-modal
  title="Изменить лимит"
>
  <div class="container">
    <mat-form-field
      class="field"
      appearance="outline"
    >
      <input
        matInput
        type="text"
        inputmode="numeric"
        [(ngModel)]="limit"
        (input)="handleInputEvent($event)"
        (keydown)="preventInvalidNumericInput($event, true)"
      >
      <mat-label>Лимит</mat-label>
    </mat-form-field>
    @if (planFactExceptionId) {
      <button
        mat-fab
        class="delete"
        (click)="handleDeleteClick()"
      >
        <mat-icon>delete</mat-icon>
      </button>
    }

  </div>
  <div class="buttons-container">
    <button
      mat-button
      tabindex="-1"
      class="save-button"
      color="primary"
      (click)="handleClick()"
    >
      {{getBtnText()}}
    </button>
    <button
      mat-button
      tabindex="-1"
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
